// Centrálna SEO konfigurácia. Produkčnú doménu potvrďte / upravte podľa potreby.
import { chapters } from "../programData";

// Produkčná doména sa berie z env; ak nie je, použije sa aktuálny origin (auto na nasadenej doméne).
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "https://www.kuranpreruzomberok.sk");
export const SITE_NAME = "Ján Kuráň – primátor pre Ružomberok";
export const DEFAULT_OG_IMAGE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_kuran-ruzomberok/artifacts/v8t6oahi_IMG_3328.webp";

// Programové oblasti (kapitoly) obohatené o absolútnu URL.
export const programAreas = chapters.map((c) => ({
  ...c,
  url: `${SITE_URL}/program/${c.slug}`,
}));

export const absUrl = (path = "/") =>
  `${SITE_URL}${path.startsWith("/") ? path : "/" + path}`;
